import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RelativeRelationship } from '../../../domain/data';
import { RelativeRelationshipCode } from '../../../../core';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-relationship',
    templateUrl: './full-data-form-relationship.component.html',
    styleUrls: ['./full-data-form-relationship.component.scss'],
})
export class FullDataFormRelationshipComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public RelativeRelationshipCode: typeof RelativeRelationshipCode = RelativeRelationshipCode;

    public prefix: string;

    @Input()
    relationship: RelativeRelationship;

    @Input()
    isDisabled = false;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfrls-${nextUniqueId++}-`;
    }
}
